import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import AddLinkIcon from "@mui/icons-material/AddLink";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import TextField from "@material-ui/core/TextField";
// import Tooltip from "@material-ui/core/Tooltip";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { InputAdornment } from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";
import FetchServerData from "../../../provider/FetchServerData";
import store from "../../../redux/store";
import {
  CreateShort_URL,
  DeleteShortLink_Url,
  ShortLinkList_Url,
} from "../../../provider/ServiceUrl";
import Utils from "../../../provider/Utils";
import RemoveContactButton from "../buttons/RemoveContactButton";
import Pagination from "../pagination/Pagination";
import PtsAlert from "../ptsAlert/PtsAlert";
// import PtsButton from "../buttons/PtsButton";
import "./ShortLinkList.css";
// import DeleteButton from "../buttons/DeleteButton";
import _ from "lodash";
class ShortLinkDialog extends Component {
  header = store.getState().header.header;
  businessDomainId = store.getState().businessDomain?.businessDomainId;

  constructor(props) {
    super(props);
    this.state = {
      messageName: "",
      shortUrl: "",
      shortlinkUrl: "",
      searchText: "",
      initialPage: 0,
      pageSize: 10,
      shortLinkList: [],
      alertVisible: false,
      open: false,
    };
    this.debouncedSearch = _.debounce(this.showShortLinkList, 800);
  }

  showShortLinkList(pageNo, pageSize) {
    const postObject = {
      header: this.header,
      page: {
        searchText: this.state.searchText,
        pageNo: pageNo,
        pageSize: pageSize,
      },
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(ShortLinkList_Url, postObject).then(
      (output) => {
        if (Utils.equalsIgnoreCase(output.status, "SUCCESS")) {
          let shortLinkList = output.data.shortLinkList;
          let page = output.data.page;
          let isPaging = false;
          if (shortLinkList.length > 10) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            pageNo: page.pageNo,
            showPerPage: page.pageSize,
            totalPages: page.totalPages,
            totalRecords: page.total,
            shortLinkList: shortLinkList,
          });
        } else {
        }
      }
    );
  }

  handleClose() {
    this.setState({ open: false });
  }

  handleMaterialTablePageChange(page, pageSize) {
    this.setState({ initialPage: page, pageSize: pageSize });
  }

  showActionButton(rowData) {
    return (
      <>
        <div style={{ display: "inline-flex", alignItems: "center" }}>
          <span className="me-2" style={{ cursor: "pointer" }}>
            <RemoveContactButton
              domainObject={rowData.mobile}
              // onClick={this.deleteContactToGroup.bind(this, rowData)}
              pageId="ActivityContact"
            />
          </span>
        </div>
      </>
    );
  }

  deleteContactToGroup(data) {
    const postObject = {
      header: this.header,
      activityId: data.activityId,
      contactId: data.contactId,
    };

    FetchServerData.callPostService(
      "/activityMs/removeContactFromActivitiy",
      postObject
    )
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.showShortLinkList();
        } else {
        }
      })
      .catch((error) => { });
  }

  handleAccountDropdownClose = () => {
    this.setState({ open: false, anchorEl: null });
  };

  handleShortlinkUrlChange(e) {
    this.setState({
      shortlinkUrl: e.target.value,
    });
  }

  createShortlinkToBackend() {
    if (this.state.shortlinkUrl === "") {
      return PtsAlert.error("Please enter URL");
    }
    const postObject = {
      header: this.header,
      url: this.state.shortlinkUrl,
      eventId: this.businessDomainId,
    };
    FetchServerData.callPostService(CreateShort_URL, postObject).then(
      (output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          this.showShortLinkList();
          let shortUrl = output.data.shortUrl;
          this.setState({
            shortUrl: shortUrl,
          });
        } else {
        }
      }
    );
  }

  deleteShortLink(data) {
    const postObject = {
      header: this.header,
      shortLink: {
        id: data.id,
        eventId: this.businessDomainId,
      },
    };
    FetchServerData.callPostService(DeleteShortLink_Url, postObject)
      .then((output) => {
        if (output.status === "SUCCESS") {
          PtsAlert.success(output.message);
          let shortLinkList = output.data.shortLinkList;
          let isPaging = false;
          if (shortLinkList.length > this.state.pageSize) {
            isPaging = true;
          }
          for (let i = 0; i < shortLinkList.length; i++) {
            shortLinkList[i].createdon = Utils.getUtcToLocal(
              shortLinkList[i].createdon
            );
          }
          this.setState({
            open: true,
            isPaging: isPaging,
            shortLinkList: shortLinkList,
          });
        } else {
        }
      })
      .catch((error) => { });
  }

  handleCopy = (copiedIndex) => {
    if (copiedIndex !== null) {
      this.setState({
        alertVisible: false,
        copiedIndex: copiedIndex,
      });
    } else {
      this.setState({
        alertVisible: true,
        copiedIndex: copiedIndex,
      });
    }

    setTimeout(() => {
      this.setState({ alertVisible: false, copiedIndex: null });
    }, 1000);
  };

  shortLinkTitle() {
    return (
      <label className="form-label ms-2" htmlFor="collapsible-supplierType">
        Or, copy a link from the list below to use again.
      </label>
    );
  }

  onSearchChange(e) {
    this.setState({ searchText: e.target.value });
    this.debouncedSearch(0, this.state.pageSize);
  }

  onPaginationChange(returnProp) {
    let counter = returnProp.counter;
    let pageNo = this.state.pageNo + counter;
    let pageSize = returnProp.showPerPage;
    let buttonIndex = returnProp.buttonIndex;
    let currentPageIndex =
      typeof counter !== "undefined" ? pageNo : buttonIndex;
    let resetPageNo = returnProp.resetPageNo;
    if (resetPageNo === true) {
      currentPageIndex = 0;
    }
    this.showShortLinkList(currentPageIndex, pageSize);
    this.setState({
      pageNo: currentPageIndex,
    });
  }

  render() {
    return (
      <Dialog
        open={this.state.open}
        onClose={this.handleAccountDropdownClose.bind(this)}
        maxWidth="xl"
        className="shortLinkDialogue"
      >
        <DialogTitle id="scroll-dialog-title">
          <span style={{ color: "#fff" }}>Create Short Link</span>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={this.handleAccountDropdownClose.bind(this)}
          style={{
            position: "absolute",
            right: 8,
            top: 4,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon style={{ color: "#fff", fontWeight: "600" }} />
        </IconButton>
        <DialogContent style={{ padding: "0px 24px 45px 24px" }}>
          <div
            md={12}
            className="tableContact"
            style={{
              // width: "800px",
              color: "#000",
              fontSize: "small",
            }}
          >
            <div className="row mt-2">
              <div className="col-md-9 mt-1" id="assetFormLabel">
                <label
                  className="form-label "
                  htmlFor="collapsible-supplierType"
                >
                  Enter/paste the link you want to shorten
                </label>
                <input
                  type="link"
                  autoComplete="off"
                  id="multiStepsFirstName"
                  name="multiStepsFirstName"
                  className="form-control"
                  value={this.state.shortlinkUrl}
                  onChange={this.handleShortlinkUrlChange.bind(this)}
                  validators={["required"]}
                  errormessages={["This field is required"]}
                />
              </div>
              <div
                className="col-md-3 align-self-center"
                style={{ marginTop: "32px" }}
              >
                {/* <PtsButton
                  btnName="Shorten"
                  onClick={this.createShortlinkToBackend.bind(this)}
                /> */}
                <Button
                  id="ptsButton"
                  type="submit"
                  variant="contained"
                  className="btn btn-default"
                  onClick={this.createShortlinkToBackend.bind(this)}
                  startIcon={<AddLinkIcon style={{ fontWeight: "600" }} />}
                >
                  Shorten
                </Button>
              </div>
            </div>
            <div className="row mt-1">
              <div className="col-md-12" style={{ height: "20px" }}>
                {this.state.shortUrl && (
                  <>
                    <label
                      className="form-label"
                      htmlFor="collapsible-supplierType"
                    >
                      Your new short link:
                    </label>
                    <a
                      href={this.state.shortUrl}
                      target="_blank"
                      className="anchortag fw-bold mt-4 ms-1"
                      style={{
                        width: "220px",
                        color: "#337ab7",
                        fontSize: "14px",
                      }}
                    >
                      {this.state.shortUrl}
                    </a>{" "}
                    &nbsp;
                    {/* <Tooltip title="Copy to clipboard" aria-label="add"> */}
                    <IconButton>
                      <CopyToClipboard
                        text={this.state.shortUrl}
                        onClick={this.onCopy}
                      >
                        <FileCopyIcon
                          style={{
                            color: "#6a7b8e",
                            fontSize: "20px",
                          }}
                          onClick={this.handleCopy.bind(this, null)}
                        />
                      </CopyToClipboard>
                    </IconButton>
                    {/* </Tooltip> */}
                    {this.state.alertVisible && (
                      <span className="CopyToClipboard">
                        Short link copied!
                      </span>
                    )}
                  </>
                )}
              </div>
            </div>
            {this.state.shortLinkList.length > 0 && (
              <div className="shortLinkMenu mt-3" style={{ width: "100%" }}>
                <div className="card rounded-0">
                  <div
                    className="row justify-content-between"
                    style={{ padding: "0.6em 1.2rem" }}
                  >
                    <div className="d-flex col-12 col-lg-5 col-xl-5 ps-2">
                      <div className="col-12 text-start totalResults align-self-center">
                        <span className="me-4">
                          Total Links: {this.state.totalRecords}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex col-12 col-lg-7 col-xl-7 justify-content-end">
                      <TextField
                        id="standard-search"
                        placeholder="Search"
                        type="text"
                        variant="standard"
                        value={this.state.searchText}
                        onChange={this.onSearchChange.bind(this)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <IconButton
                                onClick={this.showShortLinkList.bind(
                                  this,
                                  0,
                                  this.state.pageSize
                                )}
                              >
                                <SearchIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={() => {
                                  this.setState({ searchText: "" }, () => {
                                    this.showShortLinkList(
                                      0,
                                      this.state.pageSize
                                    );
                                  });
                                }}
                                disabled={!this.state.searchText}
                              >
                                <ClearIcon
                                  style={{
                                    opacity: this.state.searchText ? 1 : 0.4,
                                    fontSize: "1.25rem",
                                    color: "353538",
                                  }}
                                />
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="table-responsive paginationTable"
                    style={{ height: "335px" }}
                  >
                    <table className="table text-start table-hover">
                      <thead className="dialogPaginationTableThead">
                        <tr>
                          <th className="col">Short Link</th>
                          <th className="col">Actions</th>
                          {/* <th className="col">Target Link</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.shortLinkList?.map((rowData, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                rowData.id === this.state.messageId
                                  ? "#e6effc"
                                  : "",
                            }}
                          >
                            <td style={{ width: "450px" }}>
                              {Utils.truncateString(rowData.targetLink, 40)}
                            </td>
                            <td style={{ width: "150px" }}>
                              <>
                                <IconButton className="p-0 me-2 mb-1">
                                  <CopyToClipboard
                                    text={rowData.targetLink}
                                    onClick={this.onCopy}
                                  >
                                    <FileCopyIcon
                                      style={{
                                        color: "#6a7b8e",
                                        fontSize: "20px",
                                      }}
                                      onClick={this.handleCopy.bind(
                                        this,
                                        rowData?.id + 1
                                      )}
                                    />
                                  </CopyToClipboard>
                                </IconButton>
                                &nbsp;&nbsp;
                                {this.state.copiedIndex === rowData?.id + 1 && (
                                  <span className="CopyToClipboard">
                                    Short link copied!
                                  </span>
                                )}
                                {/* <DeleteButton
                                  title={rowData.sourceLink}
                                  domainObject={rowData.sourceLink}
                                  pageId= "shortLink"
                                  onClick={this.deleteShortLink.bind(
                                    this,
                                    rowData
                                  )}
                                /> */}
                              </>
                            </td>
                            {/* <td style={{ width: "400px" }}>
                              <a
                                href={rowData.targetLink}
                                target="_blank"
                                className="anchortag"
                              >
                                {Utils.truncateString(rowData.sourceLink, 50)}
                              </a>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {this.state.totalRecords === 0 && (
                    <div
                      className="row text-center"
                      style={{ padding: "6px 20px" }}
                    >
                      <h5 className="dataNotAvailable">No data found.</h5>
                    </div>
                  )}
                  {this.state.totalRecords > 10 && (
                    <div className="row justify-content-between pagination p-1">
                      <div className="d-flex col-12 col-lg-4 col-xl-4">
                        <div className="pageSize col-12 text-start">
                          Page {this.state.pageNo + 1} of{" "}
                          {this.state.totalPages}
                        </div>
                      </div>
                      <div className="d-flex col-12 col-lg-8 col-xl-8">
                        <div className="col-12 text-end">
                          <Pagination
                            showPerPage={this.state.showPerPage}
                            pageNo={this.state.pageNo}
                            onPaginationChange={this.onPaginationChange.bind(
                              this
                            )}
                            total={this.state.totalRecords}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}
export default ShortLinkDialog;
